module.exports = __webpack_public_path__ + "media/small/real_estate_homes_sale-small-9f3d0d30.jpeg";